import { AreaRow } from "./types";

// Valida uma linha da tabela de Área (tipo 4): apenas o título é obrigatório.
export function validateAreaRow(row: AreaRow): Record<string, string> {
  const errors: Record<string, string> = {};
  if (!String(row.titulo ?? "").trim()) errors.titulo = "Obrigatório";
  return errors;
}
